import React from 'react'

import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { toCurrency } from '../_helpers/pdfHelpers'
import Text from '../../../../components/pdf/Text'
import Grid from '../../../../components/pdf/Grid'

const GlobalTotalTable = ({ globalTotal }) => {
  return (
    <>
      <Grid justify="end" style={{ padding: '0.5rem 1rem' }}>
        <Table width="15%" style={{ border: '2px solid #333' }} color="#000">
          <TableRow style={{ backgroundColor: '#a6a6a6' }} color="#000">
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Total Global
              </Text>
            </TableCol>
          </TableRow>
          <TableRow color="#000">
            <TableCol color="#000" style={{ backgroundColor: '#ffff00' }}>
              <Text size="small" align="center" color="#000">
                {toCurrency(globalTotal)}
              </Text>
            </TableCol>
          </TableRow>
        </Table>
      </Grid>
    </>
  )
}

export default GlobalTotalTable
